<template>
    <div class="overflow-auto px-8px pt-8px pb-8px">
        <div class="header flex items-center gap-8px mb-12px cursor-pointer" @click="handleBack">
            <el-icon class=" back-icon cursor-pointer">
                <ArrowLeft />
            </el-icon>
            <div class="title">{{ title }}</div>
        </div>
        <div class="search flex items-center gap-4px" v-if="searchShow">
            <el-input v-model="searchValue" placeholder="请输入搜索内容" clearable :prefix-icon="Search"></el-input>
            <el-button type="primary" @click="handleSearch" style="background-color: #2a66ff;">搜索</el-button>
        </div>
        <div class="imageList" v-if="categoriesShow">
            <div class="menu-items" :class="{ active: selectedCategory === 'all' }"
                @click="handleCategorySelect('all')">
                全部
            </div>
            <div v-for="item in categoriesElementList.children" :key="item.id" class="menu-items"
                :class="{ active: selectedCategory === item.id }" @click="handleCategorySelect(item.id)">
                {{ item.name }}
            </div>
        </div>
        <div class="pageList">
            <div class="List">
                <div v-for="item in listItems" :key="item.id" class="image-item">
                    <elementItem :template="item" />
                </div>
            </div>
        </div>

        <el-pagination v-if="pagetotle > page.pageSize" style="margin-top: 20px; width: 100%;" background
            layout="prev, pager, next" small pager-count="5" :total="pagetotle" :page-size="page.pageSize"
            @change="pagechage" ref="pagination" />
        <div v-if="listItems.length === 0">
            <el-empty description="暂无数据" />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import { ArrowDown, Search, ArrowLeft } from '@element-plus/icons-vue'
import { getCategories, recommendations, getmaterials } from '@/api/affairs'
import { ElIcon, ElInput, ElButton, ElPagination, ElEmpty } from 'element-plus'
// @ts-ignore
import elementItem from './elmentItem.vue'
const props = defineProps<{
    categoriesElementList?: any,
    list?: any,
    searchShow?: boolean,
    categoriesShow?: boolean,
}>()
const searchValue = ref('')
const selectedCategory = ref('all') // 默认选中"全部"
const title = ref('')
let page = ref({
    pageNum: 1,
    pageSize: 30,
    type: 1,
})
const listItems = ref([]);
const pagetotle = ref(0);
const resetPagination = () => {
    page.value.pageNum = 1;
    pagetotle.value = 0;
    listItems.value = [];
}
let category_Id = ref('')
let keywords = '';
onMounted(() => {
    if (!props.categoriesShow) {
        listItems.value = props.list.materials.list
        title.value = props.list.name
        return
    }
    category_Id.value = props.categoriesElementList.id.toString();
    title.value = props.categoriesElementList.name
    getmaterialsList(props.categoriesElementList.id, true, '')
})
const getmaterialsList = (categoryId: string | number, resetData: boolean = false, searchKeywords: string = '') => {
    if (resetData) {
        page.value.pageNum = 1;

    }

    category_Id.value = categoryId.toString();
    let params = Object.assign({}, page.value, {
        "categoryId": category_Id,
        "keywords": searchKeywords,
        hotType: 3,
    })
    getmaterials(params).then(res => {
        pagetotle.value = res.data.data.total;
        listItems.value = res.data.data.list;
    }).catch(error => {
        console.error('加载数据失败:', error);
    });
}

const pagechage = (val: number) => {
    page.value.pageNum = val;
    page.value = Object.assign({}, page.value)
    console.log(page.value)
    getmaterialsList(category_Id.value, false, keywords);
}



const emit = defineEmits<{
    back: []
}>()

const handleSearch = () => {
    keywords = searchValue.value.trim();
    resetPagination(); // 重置分页
    getmaterialsList(category_Id.value, true, keywords);
}
const handleBack = () => {
    emit('back')
}
const handleCategorySelect = (categoryId: string | number) => {
    selectedCategory.value = categoryId.toString()
    resetPagination(); // 重置分页
    if (categoryId === 'all') {
        getmaterialsList(props.categoriesElementList.id, true, '')
    } else {
        getmaterialsList(categoryId, true, '')
    }
    // selectedCategory.value = categoryId
    // emit('categorySelect', categoryId)
}

</script>
<style lang="scss" scoped>
.menu-items {
    border-radius: 6px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 12px;
    background-color: #fff;

    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e0e0e0;
    color: #666;
    padding: 4px 12px;
    height: 30px;

    &:hover {
        border-color: #2a66ff;
        color: #2a66ff;
    }

    &.active {
        background-color: #2a66ff;
        border-color: #2a66ff;
        color: #fff;
        height: 30px;
    }
}

.imageList {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    width: 100%;
    margin-top: 16px;
}

.List {

    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
    width: 100%;
    margin-top: 16px;
}

.pageList {
    // height: 500px;
    max-height: calc(100vh - 280px);
    overflow: auto;
    // background: red;
}

.image-item {
    width: 100%;
}
</style>
<style>
.el-pagination.is-background .btn-next.is-active,
.el-pagination.is-background .btn-prev.is-active,
.el-pagination.is-background .el-pager li.is-active {
    background-color: #2a66ff;
    border-color: #2a66ff;
    color: #fff;
}
</style>